/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/appCardList.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_CREDENTIAL_TEMPLATES_LIST } from "../graphql";
import { VApplication } from "../../../application";

import { toHeaderCase } from "js-convert-case";

import { DEFAULT_APP_CONFIG } from "../../../config/default.config";

import { templateReplacer } from "../../../helpers/template.replace";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetServicesListProps {
  offset?: number;
  size?: number;
}

export interface IAppCardListMethods extends IPluginMethodMap {
  getAppCardListProps(args: IGetServicesListProps): Promise<any>;
}

export class AppCardListService implements IAgentPlugin {
  readonly methods: IAppCardListMethods;

  constructor() {
    this.methods = {
      getAppCardListProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetServicesListProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: GET_CREDENTIAL_TEMPLATES_LIST,
    //       variables: {
    //         input: {
    //           offset: args?.offset ?? 0,
    //           size: args?.size ?? 10,
    //         },
    //       },
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data?.getListOfCredentialSchema) {
    //       let _templateData = this.formatTemplateList(
    //         res?.data?.getListOfCredentialSchema?.data
    //       );
    //       return {
    //         appCardList: _templateData,
    //         isEmpty: res?.data?.getListOfCredentialSchema?.data?.length <= 0,
    //         // studentGroup: holderGroups,
    //         activePage: res?.data?.getListOfCredentialSchema?.currentPage,
    //         pageSize: res?.data?.getListOfCredentialSchema?.pageSize,
    //         totalCount: res?.data?.getListOfCredentialSchema?.totalCount,
    //         totalPages: res?.data?.getListOfCredentialSchema?.totalPages,
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   console.log(`error in table data`, err);
    //   return {
    //     isEmpty: true,
    //   };
    // }
    return { ...(this.getTransformConfig(config) || {}) };
  }

  private getTransformConfig(data: any) {
    const _transConfig = templateReplacer(JSON.stringify(data), {
      holder_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holder,
      holders_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holders,
      holder_group: DEFAULT_APP_CONFIG?.platformSemantics?.HoldersGroups?.title,
    });
    return JSON.parse(_transConfig);
  }

  private formatTemplateList(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          ...item,
          appCardId: item?.id,
          appCardImage: item?.logo,
          appCardTitle: item?.name ? toHeaderCase(item?.name) : "",
          appCardDescription: item?.description,
        };
      });

    return _rowData;
  }
}
